import React from "react";
import { Heading, Pane, Text } from "evergreen-ui";

const IntegrationsScreen = ({ children, description, title }) => {
  return (
    <Pane marginX={16} marginY={8}>
      <Heading is="h3">{title}</Heading>
      <Text>{description}</Text>
      {children ? <Pane marginY={16}>{children}</Pane> : null}
    </Pane>
  );
};

export default IntegrationsScreen;
